export default {
  getMessages:state=>{
    if(state.messages.length>0)
      return state.messages.sort((a,b)=>{
        if(a.messageDate>b.messageDate) return 1
        if(a.messageDate<b.messageDate) return -1
        if(a.messageDate==b.messageDate) return 0
      });
    else return []
  },

  getChatUser:state=>chatId=> {
    var ind = state.chats.findIndex(x => x.chatId == chatId);
    if (ind != -1 && ind != undefined) {
      return state.chats[ind];
    }

  }

}
